module.exports = __webpack_public_path__ + "static/media/Marotte_Chene_aurea_MT2-14-Panel.58c4ae67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Chene_aurea_MT2-14-Panel.jpg
// module id = 949
// module chunks = 37